import React from 'react';
import classNames from 'classnames';
import { Heading, LoadingIndicator } from '@dotcom/crown-ui';
import { LoaderProps } from './loader-types';
import styles from './loader.module.scss';

export const Loader = ({ title = '', isLoading }: LoaderProps) => {
  const classes = classNames(styles['loader-background'], isLoading && styles.loading);
  return (
    <div className={classes} aria-hidden={!isLoading}>
      <div className={styles['loader-wrapper']} role="alert" aria-live="polite" aria-label="Loading">
        <LoadingIndicator title="Loading indicator with three bouncing dots" className={styles['loader-indicator']} />
      </div>
      {title && (
        <Heading as="h3" className={styles['loader-title']}>
          {title}
        </Heading>
      )}
    </div>
  );
};
